import { ReactNode, useMemo } from 'react';

import TrainingCategories from '@/features/Settings/pages/Categories';
import TrainingQuestions from '@/features/Settings/pages/Questions';
import { useParams } from 'react-router-dom';

export type SettingsRouteProps = {
  route: string;
};
export type SettingsRoute = (props: SettingsRouteProps) => ReactNode;

const Training = (): ReactNode => {
  const { ['child-route']: subRoute } = useParams<Record<string, string>>();

  const Content = useMemo((): SettingsRoute => {
    switch (subRoute) {
      case 'categories':
        return TrainingCategories;
      case 'questions':
        return TrainingQuestions;
      default:
        return TrainingCategories;
    }
  }, [subRoute]);

  return <Content route={subRoute} />;
};

export default Training;
